<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Global styles if needed, but Tailwind handles most */
</style>
